import React from "react";
import { Box, Typography } from "@mui/material";
import currency from "currency.js";
import { getOptimizedCloudinaryUrl } from "../../common/component/util";

export default function ProductTile(props) {
  const { product, index = 0 } = props;

  console.log(">>>", product);
  let minPrice = 0;
  let maxPrice = 0;
  for (const variant of product.variants?.size?.field?.options || []) {
    const price = +variant.pricing.amount;
    if (minPrice === 0) {
      minPrice = price;
    } else if (price <= minPrice) {
      minPrice = price;
    } else if (price >= maxPrice) {
      maxPrice = price;
    }
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: "12px",
          flexDirection: index % 2 === 1 ? "row-reverse" : "row",
          alignItems: "center",
        }}
      >
        <Box textAlign={index % 2 === 0 ? "right" : "left"} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 0 }}>
          <Box sx={{ minHeight: 0, maxWidth: "250px" }}>
            <Typography
              textAlign={index % 2 === 0 ? "right" : "left"}
              sx={{
                mb: 0,
                lineHeight: 1,
                fontSize: "1rem",
                fontWeight: "bold",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              title={product.title}
            >
              {product.title}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              textAlign={index % 2 === 0 ? "right" : "left"}
              sx={{ mt: 0.25 }}
              style={{
                color: "#777",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                whiteSpace: "normal",
              }}
              dangerouslySetInnerHTML={{
                __html: product.description
              }}
            />
          </Box>
        </Box>
        <Box sx={{ width: "150px", height: "150px", position: "relative", flexShrink: 0 }}>
          <Box
            sx={{
              width: "150px",
              height: "150px",
              borderRadius: "50%",
              border: `1px dashed ${props.themeColor}`,
              padding: "7px",
              boxSizing: "border-box",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {product.images && product.images[0] ? (
                <img
                  key={`product-image-${index}-${product.id || product.title}`}
                  src={getOptimizedCloudinaryUrl(product.images[0], "f_auto,q_auto,w_400")}
                  alt={product.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    aspectRatio: "1",
                    objectFit: "cover",
                    display: "block",
                  }}
                  onError={(e) => {
                    console.error(`Image ${index} failed to load:`, product.images[0], product.title);
                    e.target.style.display = "none";
                  }}
                  onLoad={() => {
                    console.log(`Image ${index} loaded successfully:`, product.title);
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                  }}
                />
              )}
            </Box>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
              backgroundColor: props.themeColor,
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FFF",
              fontSize: "12px",
              fontWeight: "bold"
            }}
          >
            { `$${currency(minPrice).dollars()}` }
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
